import { render, staticRenderFns } from "./OfficialLabels.vue?vue&type=template&id=d554e4aa&scoped=true"
import script from "./OfficialLabels.vue?vue&type=script&lang=ts"
export * from "./OfficialLabels.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d554e4aa",
  null
  
)

export default component.exports